export { ProjectActionsMenu } from './ui/ProjectActionsMenu';
export { ProjectDesktopLayout } from './ui/ProjectDesktopLayout';
export { DashboardDesktopLayout } from './ui/DashboardDesktopLayout';
export { AppSidebar } from './ui/AppSidebar';
export { ProjectSwitcher } from './ui/ProjectSwitcher';
export { ProjectListMenu } from './ui/ProjectListMenu';
export { NewProjectDialog } from './ui/NewProjectDialog';
export { useNewProjectStore } from './model/new-project-store';
export { ProjectSettingsMenu } from './ui/ProjectSettingsMenu';
export { ConceptThumbnailList } from './ui/ConceptThumbnailList';
export { ProjectSettingsPanel } from './ui/ProjectSettingsPanel';
export { NavigationCircle, SectionChevron } from './ui/section-components';
export {
  ProjectHeroSection,
  SectionHeader,
  SectionPanel,
  OnboardingEmptyState,
  ProjectGoalsSection,
  ProjectAnglesSection,
  ProjectReferencesSection,
  ProjectConceptsSection,
  ProjectEstimatesSection,
  ProjectAlbumsSection,
  ProjectEmptyState,
} from './ui/ProjectPageSections';
export {
  DesktopLayoutProvider,
  useDesktopLayout,
  useOptionalDesktopLayout,
  type RenderSettingsPanelData,
} from './context/DesktopLayoutContext';
export { projectsService } from './api/projects';
export {
  ProjectPageProvider,
  useProjectPageContext,
  useOptionalProjectPageContext,
} from './context/ProjectPageContext';

// TanStack Query hooks
export {
  useProjects,
  useProject,
  useCreateProject,
  useUpdateProject,
  useDeleteProject,
  useEnhanceGoals,
  useProjectConcepts,
  useInfiniteProjects,
} from './hooks/use-projects';

